import React from "react";
import { useNavigate } from "react-router-dom";
import TableLayout from "../../layouts/TableLayout/NewTableLayout";
import { useFetchAll } from "../../hooks/useFetchAll";
import { usePermissions } from "../../hooks/usePermissions";
import { PERMISSIONS } from "../../constants/access-control";
import { COLUMN_DEFINITIONS, PAGE_SIZE_OPTIONS } from "./table.config";
import { useGetManifestsV2Query } from "../../redux/services/manifests/manifestsV2Api";
import { useConfig } from "../../hooks/useConfig";
import { getProductTerminology } from "../../constants/product-terminology";

const ManifestsV2 = () => {
  const navigate = useNavigate();
  const { appType } = useConfig();
  const terms = getProductTerminology(appType);
  const { hasAnyPermission } = usePermissions();
  const canManageManifests = hasAnyPermission([
    PERMISSIONS.MANIFESTS_CREATE,
    PERMISSIONS.MANIFESTS_EDIT,
  ]);
  const {
    pagination: { pageIndex, pageSize, setPagination },
    search: { handleGlobalSearch },
    queryResult: { data, isLoading },
  } = useFetchAll({
    queryHook: useGetManifestsV2Query,
    defaultPageSize: 20,
  });

  return (
    <TableLayout
      id="manifests-v2"
      useStyles
      title={terms.tripManifestListTitle}
      loading={isLoading}
      columns={COLUMN_DEFINITIONS}
      data={data?.manifests || []}
      pagination={data}
      pageIndex={pageIndex}
      pageSize={pageSize}
      onPaginationChange={setPagination}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      handleEdit={(itemId) => navigate(`/manifests/v2/${itemId}`)}
      fullTextSearch={handleGlobalSearch}
      noDelete
      hideCheckbox
      hideActions={!canManageManifests}
      hideMainAction={!canManageManifests}
      emptyState={{
        title: "No manifests",
        description: "Get started by adding a manifest",
      }}
      mainAction={{ onClick: () => navigate("/manifests/v2/create") }}
    />
  );
};

export default ManifestsV2;
